interface PaginationProps {
  page: number            // 0-based current page index
  totalPages: number
  totalElements: number
  isFirst: boolean
  isLast: boolean
  onPageChange: (page: number) => void
}

/**
 * Page metadata + Prev/Next controls for a Spring `Page` response.
 * Renders nothing when there are no rows.
 */
export default function Pagination({
  page,
  totalPages,
  totalElements,
  isFirst,
  isLast,
  onPageChange,
}: PaginationProps) {
  if (totalElements === 0) return null

  return (
    <div className="flex items-center justify-between px-4 py-3 text-xs text-foreground-muted border-t border-border">
      <span>{totalElements} total</span>
      <div className="flex items-center gap-3">
        <button
          type="button"
          onClick={() => onPageChange(page - 1)}
          disabled={isFirst}
          className="h-9 px-3 rounded border border-border hover:bg-surface-hover disabled:opacity-40 disabled:hover:bg-transparent"
        >
          Prev
        </button>
        <span>Page {page + 1} of {Math.max(totalPages, 1)}</span>
        <button
          type="button"
          onClick={() => onPageChange(page + 1)}
          disabled={isLast}
          className="h-9 px-3 rounded border border-border hover:bg-surface-hover disabled:opacity-40 disabled:hover:bg-transparent"
        >
          Next
        </button>
      </div>
    </div>
  )
}
